/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  Grid,
  Button
} from '../../components/index';

const ProtocoloCertidao = (props) => {
  const handleButton = () => {
    props.handleSearchPeriodos();
  }

  function verificarTamanhoInput() {
    let retorno = '4 4 4 4';
    if (props.verificaAcaoExibicaoBotaoPesquisarCTC()) {
      retorno = '5 5 5 5';
    }
    return retorno;
  }

  function verificaDesabilitarEntradaProtocoloDaCertidao() {
    return !['novo', 'cumprir-exigencia', 'indeferidos'].includes(props.estadoFormulario.acao);
  }

  function verificaDesabilitarBotaoPesquisar() {
    return !(props.estadoFormulario.requerimento.cpf);
  }

  let manterProtocoloCertidao = (
    <div>
      <Grid cols={verificarTamanhoInput()}>
        {props.verificaAcaoExibicaoBotaoPesquisarCTC() &&
          <div>
            <Button
              className="left-sem-margem-esquerda"
              title='pesquisar ctc'
              onClick={handleButton}
              hint='Pesquisar a CTC'
              disabled={verificaDesabilitarBotaoPesquisar()}
            />
          </div>
        }
        <Input
          label="Protocolo da Certidão"
          maxlength="23"
          onChange={e => props.handleChange(e, 'protocoloCertidao')}
          value={props.estadoFormulario.requerimento.protocoloCertidao}
          disabled={verificaDesabilitarEntradaProtocoloDaCertidao()}
          integer
          />
      </Grid>
    </div>
  );
return (
    <React.Fragment>
      {manterProtocoloCertidao}
    </React.Fragment>      
  );
}

ProtocoloCertidao.propTypes = {
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleChangeProtocoloNaoConstaOuIlegivel: PropTypes.func.isRequired,
  handleSearchPeriodos: PropTypes.func.isRequired,
  verificaAcaoExibicaoBotaoPesquisarCTC: PropTypes.func.isRequired,
}.isRequired;

export default ProtocoloCertidao;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/ProtocoloCertidao.jsx